/* eslint-disable */

const data_origin_code = 'INDIVIOR_SUBLOCADE_PATIENT';

const getCookie = function(name) {
    return (new RegExp('(?:^|; ?)' + name + '=([^;]*)').exec(document.cookie) || []).splice(1,1)[0];
};

const setCookie = function(name, value, settings) {
    document.cookie = name + '=' + value + ';'
      + (settings && settings.Expires ? ' Expires=' + settings.Expires + ';' : '')
      + (settings && settings.MaxAge ? ' Max-Age=' + settings.MaxAge + ';' : '')
      + ' Path=' + (settings && settings.Path || '/') + ';'
      + (settings && settings.Secure === false ? '' : (location.protocol == 'https:' ? ' Secure;' : ''))
      + ' SameSite=' + (settings && settings.SameSite || 'None') + ';';
};

const getSearchSeed = function() {
    var cookie = getCookie('searchseed');
    var seed = parseInt(cookie);

    if (!seed) {
        seed = Math.ceil(Math.random()*100)*20000000;
    }

    setCookie('searchseed', seed, { MaxAge: 60*60*24*7 });
    return seed;
};

export default {
    getCookie,
    setCookie,
    getSearchSeed,
};